<template>
    <div class="fst-LlmsTemplatesCheck">
        <div v-if="isEmpty">{{$t('llms.emptyData')}}</div>
        <el-form v-else :model="model" :show-message="false" label-position="top">
            <el-form-item v-for="(item, key) in model.parameters" :key="key" :prop="`parameters.${key}.defaultValue`" :label="key">
                <el-input v-model="item.defaultValue" type="textarea" :rows="2" @input="saveToSessionStorage()" />
            </el-form-item>
            <div v-if="(result.llm || {}).text" class="result">
                <el-divider>{{ $t('llms.templates.check.result') }}</el-divider>
                <el-form-item v-if="result.result || result.llm.text || result.llm.json">
                    <el-tabs value="result" type="border-card">
                        <el-tab-pane label="Result" name="result">
                            <JsonView :value="result.result" :open="3" previewEnabled />
                        </el-tab-pane>
                        <el-tab-pane label="Text" name="text">{{ result.llm.text }}</el-tab-pane>
                        <el-tab-pane label="JSON" name="json">
                            <JsonView :value="result.llm.json" :open="3" previewEnabled />
                        </el-tab-pane>
                    </el-tabs>
                </el-form-item>
            </div>
        </el-form>
    </div>
</template>

<script>
    import _ from 'lodash';
    import { mapActions } from 'vuex';
    import ServiceError from '@/commons/components/ServiceError.vue';
    import JsonView from '@/commons/components/JsonViewer.vue';

    export default {
        name: "LlmsTemplatesCheck",
        components: {JsonView},
        props: {
            template: {
                type: Object,
                default: () => ({})
            },
            llm: {
                type: Object,
                default: () => ({})
            }
        },
        data() {
            return {
                model: {
                    parameters: null,
                    template: _.assign({}, this.template, {llm: this.llm})
                },
                result: {}
            }
        },
        computed: {
            isEmpty() {
                return this.model.parameters && _.isEmpty(this.model.parameters);
            }
        },
        mounted() {
            this.getTemplateParameters({request: _.omit(this.template, ['data.parameters']), prepare: {target: this.$el}}).then(data => {
                let sessionStorageValue = _.get(JSON.parse(sessionStorage.getItem('llm')), `llmTemplatesCheckForm.${this.template.id}`, {});
                this.model.parameters = _.mapValues(data, (v,k) => {
                    if (sessionStorageValue[k]) {
                        _.merge(v, sessionStorageValue[k]);
                    }
                    return v;
                });
            });
        },
        methods: {
            ...mapActions('llm', ['getTemplateParameters','testTemplate']),
            apply() {
                return new Promise((resolve, reject) => {
                    if (this.isEmpty) {
                        reject(); return;
                    }
                    let model = _.assign({}, this.model, {
                        parameters: _.mapValues(this.model.parameters, 'defaultValue')
                    });
                    //console.log('apply', this.model); return;
                    this.testTemplate({request: model, prepare: {target: this.$el}}).then(resp => {
                        let data = _.cloneDeep(resp);
                        if (data.error) {
                            this.$modal.dialog(ServiceError, {
                                title: this.$t('error'),
                                size: 'md',
                                ':errors': [data.error],
                                buttons: ['close']
                            });
                        }
                        if (data.llm) {
                            try {
                                data.llm.json = JSON.parse(data.llm.service);
                            } catch (error) {}
                        }
                        if (data.result) {
                            try {
                                data.result = JSON.parse(data.result);
                            } catch (error) {}
                        }
                        this.result = data;
                        resolve(data);
                    }, reject);
                });
            },
            saveToSessionStorage() {
                let sessionStorageLlm = JSON.parse(sessionStorage.getItem('llm')) || {};
                (sessionStorageLlm.llmTemplatesCheckForm || (sessionStorageLlm.llmTemplatesCheckForm = {}))[this.template.id] = this.model.parameters;
                sessionStorage.setItem('llm', JSON.stringify(sessionStorageLlm));
            }
        }
    }
</script>

<style lang="scss">
    .fst-LlmsTemplatesCheck {
        min-height: 50px;
        .el-form {
            &-item {
                margin-bottom: 0 !important;
            }
        }
    }
</style>
